import { render, staticRenderFns } from "./dashboardImfinzi.vue?vue&type=template&id=1db764ed&"
import script from "./dashboardImfinzi.vue?vue&type=script&lang=js&"
export * from "./dashboardImfinzi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports